import React from 'react';

const FlipPhone = (props) => {

    return (

        <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
             x="0px" y="0px" viewBox="0 0 226 226">
            <path fill={'#ffffff'} d="M204.99,195.99C115.67,195.99,42.87,124,41.52,35l10.96,10.96c0.68,0.68,1.58,1.02,2.48,1.02
s1.79-0.34,2.48-1.02c1.37-1.37,1.37-3.58,0-4.95L40.46,24.04c-1.37-1.37-3.58-1.37-4.95,0L18.54,41.01c-1.37,1.37-1.37,3.58,0,4.95
c1.37,1.37,3.58,1.37,4.95,0l11.03-11.03c1.32,92.89,77.27,168.05,170.47,168.05c1.93,0,3.5-1.57,3.5-3.5
S206.92,195.99,204.99,195.99z"/>
        </svg>
    )
};

export default FlipPhone

